export const REGULAR_TASKS = [
  { id: "pip-ongoing-kipk", order: 1, title: "Pencairan PIP PT on Going & Profesi - KIPK" },
  { id: "pip-ongoing-bbp", order: 2, title: "Pencairan PIP PT on Going & Profesi - BBP" },
  { id: "pip-mahasiswa-baru-kipk", order: 3, title: "Pencairan PIP PT - Mahasiswa Baru - KIPK" },
  { id: "perjanjian-kerjasama", order: 4, title: "Perjanjian Kerjasama" },
];

export const getRegularTask = (taskId) => REGULAR_TASKS.find((task) => task.id === taskId);